"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
const projects = [{
  id: 1,
  title: "Rénovation Cuisine Moderne",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/renovation_cuisine_moderne.png"
}, {
  id: 2,
  title: "Salle de Bain Élégante",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/salle_bain_elegante.png"
}, {
  id: 3,
  title: "Extension Lumineuse",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/extension_lumineuse.png"
}, {
  id: 4,
  title: "Isolation Thermique",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/isolation_thermique.png"
}, {
  id: 5,
  title: "Aménagement Combles",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/amenagement_combles.png"
}, {
  id: 6,
  title: "Terrasse Bois",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/terrasse_bois.png"
}];
export default function TransformationsElegantes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const [selectedImage, setSelectedImage] = useState<{
    title: string;
    image: string;
  } | null>(null);
  return <section ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className={`mx-auto max-w-7xl transition-all duration-[var(--duration-slow)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <h2 className="mb-12 text-center font-display text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
          Transformations élégantes
        </h2>

        <Carousel opts={{
        align: "start",
        loop: true,
        skipSnaps: false,
        dragFree: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {projects.map((project, i) => <CarouselItem key={project.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <button onClick={() => setSelectedImage(project)} className="group relative block aspect-[4/3] w-full cursor-pointer overflow-hidden rounded-lg shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-ring" aria-label={`Voir ${project.title}`}>
                  <img src={project.image} alt={project.title} className="size-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
                  <div className="absolute inset-0 bg-primary-dark/0 transition-all duration-200 ease-[var(--ease-smooth)] group-hover:bg-primary-dark/60" />
                  <div className="absolute inset-0 flex items-end p-6 opacity-0 transition-opacity duration-200 ease-[var(--ease-smooth)] group-hover:opacity-100">
                    <h3 className="font-display text-lg font-semibold text-white sm:text-xl">
                      {project.title}
                    </h3>
                  </div>
                </button>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="hover-lift -left-4 sm:-left-12" />
          <CarouselNext className="hover-lift -right-4 sm:-right-12" />
        </Carousel>
      </div>

      <Dialog open={!!selectedImage} onOpenChange={open => !open && setSelectedImage(null)}>
        <DialogContent className="max-w-5xl border-none bg-transparent p-0 shadow-none" showCloseButton={true}>
          {selectedImage && <div className="animate-in zoom-in-95 fade-in-0 duration-[var(--duration-slow)] ease-[var(--ease-spring)]">
              <img src={selectedImage.image} alt={selectedImage.title} className="w-full rounded-lg shadow-strong" />
              <p className="mt-4 text-center font-display text-xl font-semibold text-white">
                {selectedImage.title}
              </p>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}